import React from "react";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu.tsx";
import { PlusIcon } from "lucide-react";
import { uiState } from "@/states.ts";
import { cn } from "@/lib/utils.ts";

const AddMenu: React.FC<{ className?: string; size?: number }> = ({ className, size = 24 }) => {
	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<button
					type={"button"}
					className={cn("cursor-pointer", className)}
					aria-label={"Add"}
				>
					<PlusIcon width={size} height={size} />
				</button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align={"end"}>
				<DropdownMenuItem onClick={() => (uiState.newList = true)}>
					New List
				</DropdownMenuItem>
				<DropdownMenuItem onClick={() => (uiState.newGroup = true)}>
					New Group
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
};

export { AddMenu };
